class CartCounter extends HTMLElement {
  constructor() {
    super();
    this.label = this.querySelector('[data-label]');
    document.body.addEventListener('cart:updated', this.hanldeCartUpdate.bind(this));
  }

  hanldeCartUpdate(event) {
    const { cart } = event.detail;
    const qty = cart.reduce((acc, item) => acc + item.quantity, 0);
    this.label.innerHTML = qty;

    // Toggle visibility based on quantity
    this.classList.toggle('hidden', qty === 0);
  }
}

customElements.define('cart-counter', CartCounter);
